import { render } from "./RacquetballForm.vue?vue&type=template&id=36038bf8&scoped=true&ts=true"
import script from "./RacquetballForm.vue?vue&type=script&lang=ts"
export * from "./RacquetballForm.vue?vue&type=script&lang=ts"

import "./RacquetballForm.vue?vue&type=style&index=0&id=36038bf8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36038bf8"]])

export default __exports__